import { render, staticRenderFns } from "./AnimatedDigit.vue?vue&type=template&id=6cb2844a&scoped=true&"
import script from "./AnimatedDigit.vue?vue&type=script&lang=js&"
export * from "./AnimatedDigit.vue?vue&type=script&lang=js&"
import style0 from "./AnimatedDigit.vue?vue&type=style&index=0&id=6cb2844a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cb2844a",
  null
  
)

export default component.exports